import React from 'react'
import Select from 'react-select'
import FormRowWrapper from '../FormRowWrapper/FormRowWrapper'

import './auto-complete.scss'

const staticStyles = {
  wrapperStyle: base => ({ ...base, width: 800 }),
}

/**
 * renders auto complete drop down element
 * @param {Array<{id: string, value: string | number}>} options
 */
const autoCompleteSelect = ({
  name,
  title,
  placeholder,
  input,
  meta: { touched, error },
  options,
  styles,
  isLoading,
  isDisabled,
  ...custom
}) => {
  let hasError = touched && error !== undefined

  const value = input.value || typeof input.value === typeof true
    ? Array.isArray(input.value)
      ? input.value
          .map(itemId => options.find(item => item.id === itemId))
          .filter(Boolean)
      // : input.value
      : options.find(item => item.id === input.value || input.value && item.id === input.value.id)
    : undefined

  const handleChange = value =>
    input.onChange(Array.isArray(value) ? value.map(item => item.id) : value)

  return (
    <FormRowWrapper title={title} fieldName={name} hasError={hasError} error={error}>
      <Select
        {...input}
        {...custom}
        styles={{
          ...staticStyles,
          ...styles
        }}
        value={value}
        onChange={handleChange}
        options={options}
        isRtl={true}
        getOptionLabel={option => option.title}
        getOptionValue={option => option.id}
        placeholder={isLoading? 'در حال بارگزاری...' : placeholder || 'انتخاب'}
        isDisabled={isDisabled || isLoading}
        classNamePrefix="react-select"
        onBlur={() => { input.onBlur(input.value) } }
      />
    </FormRowWrapper>
  )
}

export default autoCompleteSelect



// WEBPACK FOOTER //
// ./src/components/common/FormFields/AutoCompleteSelect/AutoCompleteSelect.js